var MemoryStorage = require('memorystorage');

export class StorageHolder {

    private static _localStorage: Storage;

    private static _init = (() => {

        try {
            StorageHolder._localStorage = window.localStorage;
            let test = 'test_localstorage_available_' + Date.now();
            StorageHolder._localStorage.setItem(test, test);
            let actual = StorageHolder._localStorage.getItem(test);
            StorageHolder._localStorage.removeItem(test);
            if (test !== actual) {
                StorageHolder._localStorage = StorageHolder.createStorage();
            }

        } catch (e) {
            StorageHolder._localStorage = StorageHolder.createStorage();
        }
    })();

    static get localStorage() : Storage {
        return StorageHolder._localStorage;
    }

    private static createStorage() : Storage {
        return new MemoryStorage();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/core/storage/StorageHolder.ts